import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { groupBy } from 'lodash';
import { Title } from 'components/atoms/title';
import RentalHouseCard from 'components/atoms/rentalHouseCard';
import { RouteUtil } from 'utils/RouteUtil';
import { ArrayUtil } from 'utils/ArrayUtil';
import locationMarker from 'assets/images/marker.png';
//eslint-disable-next-line
import styles from "./styles.scss";

const RentalsOverlay = props => {
  let { overlayData } = props;
  const houseCount = overlayData.length;
  const rentals = groupBy(overlayData, 'name');
  const locationCount = Object.keys(rentals).length;
  const updatedData = ArrayUtil.getUniqFormattedData(overlayData, 'name');

  const onCardClick = urlSlug => {
    if (urlSlug.isCompletedProject) {
      RouteUtil.setRouteChange(
        props,
        `/rentals/${urlSlug.rental_home_url_slug}`
      );
    } else {
      RouteUtil.setRouteChange(
        props,
        `/rentals/${urlSlug.projectSlug}/${urlSlug.productSlug}/${urlSlug.rental_home_url_slug}`
      );
    }
  };

  return (
    <div className={'rentals-overlay'}>
      <Row className={'grid-view-header'}>
        <Title
          firstText={
            houseCount === 1
              ? `${houseCount} rental home`
              : `${houseCount} rental homes`
          }
          secondText={
            locationCount === 1
              ? `${locationCount} location`
              : `${locationCount} locations`
          }
        />
      </Row>
      <Row
        className={
          overlayData.length === 1
            ? 'rental-overlay-grid no-height'
            : 'rental-overlay-grid'
        }
      >
        {updatedData.map((key, idx) => {
          const card = key.rental_house;
          return (
            <>
              <div className={'project-name-container'} id={idx}>
                <img src={locationMarker} alt={'location'} />
                <div className={'name-location'}>
                  <h3>{key.name}</h3>
                  <span>{key.location}</span>
                </div>
              </div>
              {card.map((house, idx) => {
                return (
                  <Col md={4} key={idx} className={'house-card'}>
                    <RentalHouseCard
                      bathCount={house.bath}
                      bedCount={house.bed}
                      imagePath={house.image}
                      price={`${house.price}${' '}${house.postFix}`}
                      onClick={() => onCardClick(house)}
                    />
                  </Col>
                );
              })}
            </>
          );
        })}
      </Row>
    </div>
  );
};

export default withRouter(RentalsOverlay);
